import PropTypes from 'prop-types';
import { Box, ListItem, ListItemText, Grid } from '@mui/material';
import PaginatedList from 'src/components/ui/list/paginated-list';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import HeaderCellText from 'src/components/ui/list/header-cell-text';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  const renderItem = (item, rowstyle) => (
    <>
      <ListItem
        divider={true}
        key={item.id}
        sx={rowstyle}
        onClick={() => onDetailClicked(item)}
      >
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <ListItemText sx={{ color: 'primary.main' }}>{item.repairDate}</ListItemText>
          </Grid>
          <Grid item xs={4} sx={{textAlign: 'center'}}>
            <ListItemText>{item.plateNumber}</ListItemText>
          </Grid>
          <Grid item xs={4} sx={{ textAlign: 'right' }}>
            <ListItemText>{item.atKm}</ListItemText>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'right', fontSize: '0.9rem'}}>
            {item.services.map((service, index) => (
              <span key={service.value}>
                {index + 1}. {service.label}
                {index < item.services.length - 1 && "; "}
              </span>
            ))}
          </Grid>
        </Grid>
      </ListItem>
    </>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items}
        loading={dataStore.loading}
        renderItem={renderItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      >
        <HeaderCellText sx={{width: '33%'}}>
          {t(appStr.txt_030)}
        </HeaderCellText>
        <HeaderCellText sx={{textAlign: 'center'}}>
          {t(appStr.txt_034)}
        </HeaderCellText>
        <HeaderCellText sx={{width: '33%', textAlign: 'right'}}>
          {t(appStr.txt_054)}
        </HeaderCellText>
        
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
